/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/review-form/index.ts":
/*!**********************************!*\
  !*** ./src/review-form/index.ts ***!
  \**********************************/
/***/ (function() {

eval("\nwindow.addEventListener(\"DOMContentLoaded\", function () {\n    //URLSearchParams\n    {\n        var params = Object.fromEntries(new URLSearchParams(window.location.search));\n        console.log(params);\n        // order_number\n        if (params[\"order_number\"]) {\n            var reviewNumberEl = document.querySelector(\"#ContactForm-reviewNumber\");\n            if (reviewNumberEl) {\n                reviewNumberEl.value = params[\"order_number\"];\n            }\n        }\n        // product_name\n        if (params[\"product_name\"]) {\n            var reviewProductNameEl = document.querySelector(\"#ContactForm-reviewProductName\");\n            if (reviewProductNameEl) {\n                reviewProductNameEl.value = params[\"product_name\"];\n            }\n        }\n    }\n});\n\n\n//# sourceURL=webpack://coding/./src/review-form/index.ts?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/review-form/index.ts"]();
/******/ 	
/******/ })()
;